export default {
  H87: 'Stück',
  MGM: 'mg',
  GRM: 'g',
  KGM: 'kg',
  MLT: 'ml',
  LTR: 'Liter',
  PTN: 'Portion | Portionen',
  '1N': 'Anzahl',
  CLT: 'cl',
  CMK: 'cm²',
  CMQ: 'cm³',
  CMT: 'cm',
  DLT: 'dl',
  DMK: 'dm²',
  DMQ: 'dm³',
  DMT: 'dm',
  E27: 'Dosis | Dosen',
  E55: 'Gebrauchseinheit | Gebrauchseinheiten',
  EA: 'Eines',
  HLT: 'hl',
  KMT: 'km',
  KT: 'Kit | Kits',
  MMK: 'mm²',
  MMQ: 'mm³',
  MMT: 'mm',
  MTK: 'm²',
  MTQ: 'm³',
  MTR: 'Meter',
  PR: 'Paar',
  SET: 'Set | Sets',
  TNE: 'Tonne | Tonnen',
  U2: 'Tablette | Tabletten',
  XRO: 'Rolle | Rollen'
}



// WEBPACK FOOTER //
// ./src/i18n/de/uom.js